// eslint-disable-next-line import/no-extraneous-dependencies
import { faker } from '@faker-js/faker/locale/fr';
import { ConsumptionModeType } from 'services/consumptionMode/consumptionMode.type';
import {
    ChannelId,
    OrderCreated,
    OrderRecap,
    OrderToVerify,
    OrderVerified,
    PriceBreakdown,
    ProductDTO,
    ProductRecap,
    StepDTO,
} from 'services/order/order.type';

faker.locale = 'fr';

export const orderStepFixtureFactory = (params: Partial<StepDTO> = {}): StepDTO => {
    const defaultValues: StepDTO = {
        stepId: 1,
        products: [],
    };

    return { ...defaultValues, ...params };
};

export const orderProductFixtureFactory = (params: Partial<ProductDTO> = {}): ProductDTO => {
    const defaultValues: ProductDTO = {
        productId: 1,
        quantity: ChannelId.WEB,
        steps: [],
    };

    return { ...defaultValues, ...params };
};

export const orderTotalPriceFixtureFactory = (
    params: Partial<PriceBreakdown> = {},
): PriceBreakdown => {
    const defaultValues: PriceBreakdown = {
        totalInclTax: faker.datatype.number(),
        totalExclTax: faker.datatype.number(),
        totalTax: faker.datatype.number(),
        totalInclTaxWithDiscount: faker.datatype.number(),
        totalExclTaxWithDiscount: faker.datatype.number(),
        totalTaxWithDiscount: faker.datatype.number(),
        totalInclTaxWithRemise: faker.datatype.number(),
        totalExclTaxWithRemise: faker.datatype.number(),
        totalTaxWithRemise: faker.datatype.number(),
    };

    return { ...defaultValues, ...params };
};

export const orderProductRecapFixtureFactory = (
    params: Partial<ProductRecap> = {},
): ProductRecap => {
    const defaultValues: ProductRecap = {
        label: 'product 1',
        id: 1,
        taxRate: 1000,
        totalPrice: orderTotalPriceFixtureFactory(params.totalPrice),
        unitPrice: orderTotalPriceFixtureFactory(params.unitPrice),
        depth: 0,
        quantity: 1,
    };

    return { ...defaultValues, ...params };
};

export const orderRecapFixtureFactory = (params: Partial<OrderRecap> = {}): OrderRecap => {
    const defaultValues: OrderRecap = {
        products: [orderProductRecapFixtureFactory()],
        totalPrice: orderTotalPriceFixtureFactory(),
    };

    return { ...defaultValues, ...params };
};

export const orderToVerifyFixtureFactory = (params: Partial<OrderToVerify> = {}): OrderToVerify => {
    const defaultValues: OrderToVerify = {
        restaurantId: 1,
        channelId: ChannelId.WEB,
        consumptionMode: ConsumptionModeType.MODE_SIT_IN,
        menuId: 1,
        cart: [],
        promocode: '',
        comment: '',
    };

    return { ...defaultValues, ...params };
};

export const orderVerifiedFixtureFactory = (params: Partial<OrderVerified> = {}): OrderVerified => {
    const defaultValues: OrderVerified = {
        ...orderToVerifyFixtureFactory(params),
        recap: orderRecapFixtureFactory(),
    };

    return { ...defaultValues, ...params };
};

export const orderCreatedFixtureFactory = (params: Partial<OrderVerified> = {}): OrderVerified => {
    const defaultValues: OrderCreated = {
        orderId: 1,
        ...orderVerifiedFixtureFactory(params),
    };

    return { ...defaultValues, ...params };
};
